import { Component } from '@angular/core';
@Component({
  selector: 'app-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss']
})
export class LinkComponent {
  backIconClass = 'icon-chevron-left';
  nextIconClass = 'icon-chevron-right';
  sizeList = ['large', 'medium', 'small', 'extraSmall'];
  size = 'medium';
  colorList = ['primary', 'secondary', 'tertiary'];
  color = 'primary';
  link1: { label: string, ariaLabel:string, hyperLink: string, target: string } =
    { label: 'link1', hyperLink: 'https://www.macmillaneducationeverywhere.com/terms-conditions/', ariaLabel: 'links', target: '_blank' };
  link2: { label: string, target: string } =
    { label: 'link2', target: '_self' };
  link3: { label: string, hyperLink: string, target: string } =
    { label: 'link3', hyperLink: '/button', target: '_self' };
  link4: { label: string, hyperLink: string, target: string } =
    { label: 'लिन', hyperLink: 'https://www.google.com/', target: '_blank' };
  link5: { label: string, hyperLink: string, target: string } =
    { label: 'Enlace', hyperLink: 'https://www.google.com/', target: '_blank' };
  link6: { label: string, hyperLink: string, target: string, url: string, queryParams: {}} =
    { label: 'link8', hyperLink: '/button', target: '_blank',url:'/button', queryParams:{ test: 'dummy'} };
}
